import { CircleArrowIcon, CircleBulletIcon } from 'canoe';

import { ContentType } from '@candu-ai/content/types';

export const FLOATING_MENU_CUSTOMIZATION = {
  [ContentType.HotspotGroup]: {
    badgeLabel: 'Hotspot',
    addLabel: 'Add Hotspot',
    Icon: CircleBulletIcon,
  },
  [ContentType.Tour]: {
    badgeLabel: 'Tour Step',
    addLabel: 'Add Step',
    Icon: CircleArrowIcon,
  },
};
